// extracted by mini-css-extract-plugin
export default {"root":"styles__root__FJ2e3","small":"styles__small__v21gQ","success":"styles__success__TeNPi"};